import { render, staticRenderFns } from "./EndTermResultRow.vue?vue&type=template&id=6f5c6eb2"
import script from "./EndTermResultRow.vue?vue&type=script&lang=js"
export * from "./EndTermResultRow.vue?vue&type=script&lang=js"
import style0 from "./EndTermResultRow.vue?vue&type=style&index=0&id=6f5c6eb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports